
import React, { Component } from "react";
import { MDBNotification,MDBContainer } from "mdbreact";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
 
const initState ={
    annoucements :[
        {id :'1', title : 'new product  gggggggggg  launch', content: ' love me like u do..'},
        {id :'2', title : 'holiday', content: ' love me like u do.'},
        {id :'3', title : 'employement', content: ' love me like u do..'},
    ],
    status :  null

   }


   const announcementReducer = (state=initState,action) => {
       
       switch(action.type){
           case 'CREATE_ANNOUNCEMENT':
               console.log('created announcement',action.annoucement);
               return{
                    ...state,
                    status : 'announcement create sucessfully'
                 };
           case 'CREATE_ANNOUNCEMENT_ERROR':
               console.log('create announcement error', action.err);
               return state;
           default:
               return state;
       } 
      
   }
   
   export default announcementReducer;